/* tslint:disable */
/* eslint-disable */
/**
 * leverup Service Application
 * Documentation for your application APIs v1.0
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedPositionResponse,
} from '../models/index';

export interface GetUserOpenPositions5dIueysRequest {
    blockChain: GetUserOpenPositions5dIueysBlockChainEnum;
    userAddress: string;
    page?: number;
    size?: number;
}

export interface GetUserPositionsCBBmZuQRequest {
    blockChain: GetUserPositionsCBBmZuQBlockChainEnum;
    userAddress: string;
    page?: number;
    size?: number;
    timestampAfter?: number;
    closeTimeAfter?: number;
}

/**
 * 
 */
export class UserPositionControllerApi extends runtime.BaseAPI {

    /**
     */
    async getUserOpenPositions5dIueysRaw(requestParameters: GetUserOpenPositions5dIueysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedPositionResponse>> {
        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getUserOpenPositions5dIueys().'
            );
        }

        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getUserOpenPositions5dIueys().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/user/{user_address}/open-positions`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getUserOpenPositions5dIueys(requestParameters: GetUserOpenPositions5dIueysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedPositionResponse> {
        const response = await this.getUserOpenPositions5dIueysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUserPositionsCBBmZuQRaw(requestParameters: GetUserPositionsCBBmZuQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedPositionResponse>> {
        if (requestParameters['blockChain'] == null) {
            throw new runtime.RequiredError(
                'blockChain',
                'Required parameter "blockChain" was null or undefined when calling getUserPositionsCBBmZuQ().'
            );
        }

        if (requestParameters['userAddress'] == null) {
            throw new runtime.RequiredError(
                'userAddress',
                'Required parameter "userAddress" was null or undefined when calling getUserPositionsCBBmZuQ().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockChain'] != null) {
            queryParameters['block_chain'] = requestParameters['blockChain'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['timestampAfter'] != null) {
            queryParameters['timestamp_after'] = requestParameters['timestampAfter'];
        }

        if (requestParameters['closeTimeAfter'] != null) {
            queryParameters['close_time_after'] = requestParameters['closeTimeAfter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/user/{user_address}/positions`.replace(`{${"user_address"}}`, encodeURIComponent(String(requestParameters['userAddress']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getUserPositionsCBBmZuQ(requestParameters: GetUserPositionsCBBmZuQRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedPositionResponse> {
        const response = await this.getUserPositionsCBBmZuQRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetUserOpenPositions5dIueysBlockChainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum GetUserPositionsCBBmZuQBlockChainEnum {
    Monad = 'MONAD'
}
